import React, { memo, useCallback } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';

const NumberInput = (props)=>{

  const  {
    item,
    className,
    validationForms,
    fieldObj
  } = props;
  let input_prev_value = null;
  const fieldOnChangeHandler = useCallback((e)=>{
    const {onChangeInputAction} = props;
    let input_value = e.target.value.replace(/(\.\%)/,''); 
    if((input_value.search(/^[0]{1,}[\d]/)!==-1 || // takes care of leading zeroes
      input_value.search(/^(\d+)?[-]?([\d]{1,9})?([\%])?$/)===-1) &&  //main pattern
      input_value!==''){
      e.target.value  = (input_prev_value!==undefined)?input_prev_value:'';
      onChangeInputAction(fieldObj,e)
    }else {  
        e.target.value = (input_value!==undefined)?input_value:'';
        input_prev_value = e.target.value;
        onChangeInputAction(fieldObj,e);
    }
  }); 

  const preventNonNumericalInput = useCallback((e)=> {
    if(props.isAllowNegative===false){
      e = e || window.event;
      let charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
      let charStr = String.fromCharCode(charCode);
      if (!charStr.match(/^[0-9]+$/))
        e.preventDefault();
    }
  });
  
  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms);

  return (
    <FormBlocks {...props}  attr={attr}>
        <input 
          value={attr.value}
          onKeyPress={e=>preventNonNumericalInput(e)}
          type="text"
          onChange={e => fieldOnChangeHandler(e)}
          onBlur={(e)=>props.onBlurHandlerAction(fieldObj,e)}
          {...attr.fieldAttributes}
        />
    </FormBlocks>
  );
}


NumberInput.defaultProps = {
  className: "form-control",
  isAllowNegative:true
}
const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}

export default memo(NumberInput,isDiffProps);
